module.exports = __webpack_public_path__ + "static/media/contact-us-highlight-icon.1b064066.svg";